export function isClient() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export function isUrl(url: any) {
  return /^(https|http):\/\//.test(url)
}

export function isIOSClient() {
  return window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

// 是否在标准签app内
export function isInEsignApp() {
  return navigator.userAgent.indexOf('EsignClient') > -1
}

export function goLoginPage(type = 'login') {
  const redirect = encodeURIComponent(`${window.location.href}&sroucePage=${type}`)

  const origin =
    process.env.groupId === 'mobile-sheild-isolate'
      ? `http://usercenter-front-2-stable-${process.env.groupId}.projectk8s.tsign.cn/`
      : process.env.VUE_APP_LOGIN_URL

  window.location.href = `${origin}usercenterFront/loginMiddle/${type}?redirectUrl=${redirect}`
}

export function generateID() {
  const chars = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ]
  let res = ''
  for (let i = 0; i < 8; i += 1) {
    const id = Math.ceil(Math.random() * 35)
    res += chars[id]
  }

  return res
}

// 获取url参数
export function getQueryStrings() {
  const url = window.location.search
  const theRequest = {}
  if (url.indexOf('?') !== -1) {
    const str = url.substr(1)
    const strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }

  return theRequest
}

/**
 * a 标签 open new tab 和 下载
 * url：地址 或 资源
 * open：是否打开新的 tab 页面
 */
export const download = (url, downloadName = '', open = false) => {
  console.log('url, open', url, open)
  if (!url) return

  // 创建下载标签
  const aEle = document.createElement('a')
  aEle.href = url
  aEle.download = downloadName
  document.body.appendChild(aEle)
  aEle.click()
  aEle.remove()

  return
}

/**
 * 检测浏览器是否IE
 */
export const isBrowser = () => {
  // 取得浏览器的userAgent字符串
  const { userAgent } = navigator

  // 判断是否Opera浏览器
  const isOpera = userAgent.indexOf('Opera') > -1
  if (isOpera) {
    return 'Opera'
  }

  // 判断是否Firefox浏览器
  if (userAgent.indexOf('Firefox') > -1) {
    return 'FF'
  }

  // 判断是否Chrome浏览器
  if (userAgent.indexOf('Chrome') > -1) {
    return 'Chrome'
  }

  // 判断是否Safari浏览器
  if (userAgent.indexOf('Safari') > -1) {
    return 'Safari'
  }

  // 判断是否IE浏览器
  if (
    (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) ||
    userAgent.indexOf('rv:11.0) like Gecko') > -1
  ) {
    return 'IE'
  }
}

export function queryParams(obj) {
  return Object.keys(obj)
    .map(key => `${key}=${obj[key]}`)
    .join('&')
}
